export default {"src":"/_next/static/media/Belfius.4e438b38.svg","height":112,"width":112,"blurWidth":0,"blurHeight":0};